import { Helmet } from 'react-helmet-async'

interface SEOProps {
  title: string
  description: string
  keywords?: string
  canonical?: string
  ogImage?: string
  ogType?: string
  structuredData?: object
}

export function SEO({ 
  title, 
  description, 
  keywords = "dental clinic, dentist Chennai, Dr. Aishwarya V, dental care, teeth cleaning, root canal, dental implants, orthodontics, cosmetic dentistry, Madipakkam dental clinic, Puzhuthivakkam dentist, Chennai dental care, dental emergency, teeth whitening, pediatric dentistry", 
  canonical,
  ogImage = "/og-image.jpg",
  ogType = "website",
  structuredData
}: SEOProps) {
  const siteUrl = "https://sssdental.com"
  const fullTitle = title.includes("Sri Sai Sabari") ? title : `${title} | Sri Sai Sabari Dental Clinic`
  const defaultDescription = "Sri Sai Sabari Dental Clinic in Chennai offers comprehensive dental care by Dr. Aishwarya V. Services include general dentistry, cosmetic procedures, orthodontics, and emergency care. Book your appointment today!"

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Dr. Aishwarya V, Sri Sai Sabari Dental Clinic" />
      <meta name="robots" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={`${siteUrl}${canonical}`} />}
      
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical ? `${siteUrl}${canonical}` : siteUrl} />
      <meta property="og:image" content={`${siteUrl}${ogImage}`} />
      <meta property="og:site_name" content="Sri Sai Sabari Dental Clinic" />
      <meta property="og:locale" content="en_IN" />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content={`${siteUrl}${ogImage}`} />
      
      {/* Additional Meta Tags */}
      <meta name="geo.region" content="IN-TN" />
      <meta name="geo.placename" content="Chennai" />
      <meta name="geo.position" content="12.9171;80.2707" />
      <meta name="ICBM" content="12.9171, 80.2707" />
      
      {/* Business Info */}
      <meta name="contact" content="smile@sssdental.com" />
      <meta name="phone" content="+91-9841817510" />
      <meta name="coverage" content="Chennai, Tamil Nadu, India" />
      <meta name="distribution" content="global" />
      <meta name="rating" content="general" />
      
      {/* Google Analytics */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-335EBVP04G"></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-335EBVP04G');
        `}
      </script>

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  )
}